import * as React from 'react'
import { connect } from 'react-redux'
import { Button } from 'DVWebNodeUI'
import { ModalTrigger, ModalRenderPropArgs } from '../../utils/ModalTrigger'
import { IDetailPageState } from '../../reducers'
import { ActionBoxState } from '../../reducers/actionBox'
import * as utilityClasses from '../utilityClasses.module.scss'
import { StringId } from '../localizer/stringId'
import { TextLocalizer } from '../localizer/localizer'

type PurchaseFailedModal = ReturnType<typeof mapStateToProps>

export const PurchaseFailedModalComponent = ({ useMFA, actionBox, purchase }: PurchaseFailedModal) => {

  const errorHeader = actionBox && actionBox.main && actionBox.main.errorHeader
  const isOpen = useMFA
    ? Boolean(purchase && purchase.failed)
    : Boolean(
        actionBox &&
          actionBox.main &&
          actionBox.main.state === ActionBoxState.failed
      )

  return (
    <ModalTrigger
      modalId='dvui-close-overlay-purchase-failed'
      isOpen={isOpen}
      modalHeader={errorHeader}
      modalContent={<TextLocalizer stringID={StringId.AVOD_DP_E_error_text} />}
      modalFooter={
        ({ closeModal }: ModalRenderPropArgs) => {
          const handleClick = () => {
            window.location.reload(true)
            closeModal()
          }
          return (
            <Button className={utilityClasses.alwaysInline} onClick={handleClick} >
              <TextLocalizer stringID={StringId.AVOD_DP_E_error_ok} />
            </Button>
          )
        }
      } />
  )
}

const mapStateToProps = (state: IDetailPageState) => ({
  useMFA: state.features.useMFA,
  actionBox: state.actionBox,
  purchase: state.purchase
})

export const PurchaseFailedModal = connect(mapStateToProps)(PurchaseFailedModalComponent)
